import {
  CatenaLinkedFleetStatus,
  Telematics_Catena_LinkedFleet_Read,
} from '@treadinc/horizon-api-spec';
import dayjs, { Dayjs } from 'dayjs';

export class CatenaLinkedFleet {
  constructor(
    private _id: string,
    private _company_id: string,
    private _catena_fleet_id: string | null,
    private _invitation_id: string | null,
    private _status: CatenaLinkedFleetStatus | null,
    private _magic_link_url: string | null,
    private _fleet_ref: string | null,
    private _accepted_at: Dayjs | null,
    private _declined_at: Dayjs | null,
    private _decline_reason: string | null,
    private _discarded_at: Dayjs | null,
    private _created_at: Dayjs,
    private _updated_at: Dayjs,
  ) {}

  public get id() {
    return this._id;
  }

  public get companyId() {
    return this._company_id;
  }

  public get catenaFleetId() {
    return this._catena_fleet_id;
  }

  public get invitationId() {
    return this._invitation_id;
  }

  public get status() {
    return this._status;
  }

  public get isConnected() {
    return this._status === CatenaLinkedFleetStatus.CONNECTED;
  }

  public get magicLinkUrl() {
    return this._magic_link_url;
  }

  public get fleetRef() {
    return this._fleet_ref;
  }

  public get acceptedAt() {
    return this._accepted_at;
  }

  public get declinedAt() {
    return this._declined_at;
  }

  public get declineReason() {
    return this._decline_reason;
  }

  public get discardedAt() {
    return this._discarded_at;
  }

  public get createdAt() {
    return this._created_at;
  }

  public get updatedAt() {
    return this._updated_at;
  }

  public static parse(proto: Telematics_Catena_LinkedFleet_Read) {
    return new CatenaLinkedFleet(
      proto.id,
      proto.company_id,
      proto.catena_fleet_id ?? null,
      proto.invitation_id ?? null,
      proto.status ?? null,
      proto.magic_link_url ?? null,
      proto.fleet_ref ?? null,
      proto.accepted_at ? dayjs(proto.accepted_at) : null,
      proto.declined_at ? dayjs(proto.declined_at) : null,
      proto.decline_reason ?? null,
      proto.discarded_at ? dayjs(proto.discarded_at) : null,
      dayjs(proto.created_at),
      dayjs(proto.updated_at),
    );
  }
}
